module.exports = __webpack_public_path__ + "img/detail-btn-hen.29170c21.png";